import { render } from "./metricBox.vue?vue&type=template&id=2fdfe822&scoped=true"
import script from "./metricBox.vue?vue&type=script&lang=js"
export * from "./metricBox.vue?vue&type=script&lang=js"

import "./metricBox.vue?vue&type=style&index=0&id=2fdfe822&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdfe822"]])

export default __exports__